
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns095412ced8aa9779ef0534f17a7e04b1en from './en.yaml'
            i18n.addResourceBundle('en', '095412ced8aa9779ef0534f17a7e04b1', flattenObject(ns095412ced8aa9779ef0534f17a7e04b1en), true, true);
        
        export default '095412ced8aa9779ef0534f17a7e04b1';
    